<template>
    <div></div>
</template>

<script>
/**
 * Компонент карты для страниц с выбором адреса для доставки.
 * @emits map-click-coords (coords) - координаты клика
 * @emits map-click-address (text) - адрес клика
 * @method findRouteDistance(from, to) - найдёт маршрут и вернёт дистанцию
 * */
export default {
    name: "YandexMap",
    props: [
        "initialCoords",
        "polygons",
        "promoPolygon",
        "shipmentCity",
        "curentRegionUid",
        "deliveryCalculator1C",
        "isCheckout",
    ],

    data() {
        return {
            /** Инстанс Яндекс карт */
            yaMap: null,
            /** маршрут на карте */
            multiRoute: null,
            /** Координаты предыдущего клика */
            lastClickCoords: null,
            /* Объект выбранной метки */
            placemarkObject: null,
            /* массив объектов Polygon */
            polygonObjectList: [],
            /* UID выбранной зоны на карте */
            selectedZoneUID: null,
            /* Объект полигона зоны действия промокода */
            promoPolygonObject: null,
            /* Находится ли адрес внутри промо полигона */
            isAddressInPromoPolygon: false,
            /* Найден ли промо полигон для выбранного региона */
            isPromoPolygonInCurrentRegion: false,
        };
    },

    mounted() {
        if (typeof ymaps !== "undefined") {
            ymaps.ready(() => {
                this.createYaMap();
            });
        }
    },
    watch: {
        shipmentCity: function (value) {
            this.changeRegionPolygon(value.STORE.XML_ID);
        },
    },
    methods: {
        onMapClick(address) {
            if (this.selectedZoneUID != null) {
                address.selectedZoneUID = this.selectedZoneUID;
            }
            this.$emit("map-click-address", address);
        },
        /** Создаёт Яндекс карту */
        createYaMap() {
            const currentCityCoords =
                Array.isArray(this.initialCoords) && this.initialCoords.length == 2
                    ? this.initialCoords
                    : [55.76, 37.64]; // дефолтные кооринаты = Москва
            const state = {
                center: currentCityCoords,
                zoom: 10,
                controls: ["zoomControl"],
            };
            const options = {
                searchControlProvider: "yandex#map", // Поиск только по топонимам.
                // searchControlProvider: 'yandex#search', // Поиск по топонимам и организациям.
                yandexMapDisablePoiInteractivity: true, // Отключить маркеры
                autoFitToViewport: "always", // Растянуть карту на весь контейнер
            };
            this.yaMap = new ymaps.Map(this.$el, state, options);

            if (this.promoPolygon) {
                this.addPromoPolygon();
            } else {
                this.isPromoPolygonInCurrentRegion = false;
            }

            let regionId = this.shipmentCity ? this.shipmentCity.STORE.XML_ID : null;
            this.changeRegionPolygon(regionId);

            this.addYaMapEvents();
        },

        addPromoPolygon(coords = null) {
            let isPolygonsVisible = localStorage.getItem("visiblePolygons") == "true";
            let promoPolygonCoords = coords ? JSON.parse(coords) : JSON.parse(this.promoPolygon);
            let promoPolygonObject = new ymaps.GeoObject(
                {
                    geometry: {
                        type: "Polygon",
                        coordinates: [promoPolygonCoords],
                        fillRule: "nonZero",
                    },
                },
                {
                    // опции геообъекта.
                    fillColor: "#bfcf30",
                    strokeColor: "#000000",
                    opacity: isPolygonsVisible ? 0.5 : 0,
                    strokeWidth: isPolygonsVisible ? 3 : 0,
                    strokeStyle: "dashdot",
                    interactivityModel: "default#transparent",
                }
            );

            this.polygonObjectList.push(promoPolygonObject);
            this.yaMap.geoObjects.add(promoPolygonObject);
            this.promoPolygonObject = promoPolygonObject;
            this.isPromoPolygonInCurrentRegion = true;
        },

        addYaMapEvents() {
            this.yaMap.events.add("click", (e) => this.onClickMap(e));
        },

        /** Вызывается при клике на карту */
        async onClickMap(event) {
            const coords = event.get("coords");
            this.lastClickCoords = coords;
            this.addressText = "";

            this.markCurrentCoords(coords);
            this.$emit("map-click-coords", coords);

            this.findPolygon(coords);
        },

        async markCurrentCoords(coords) {
            if (this.placemarkObject !== null) {
                let currentCoords = this.placemarkObject.geometry.getCoordinates();
                if (currentCoords[0] == coords[0] && currentCoords[1] == coords[1]) {
                    return false;
                }
            }
            this.findPolygon(coords);
            if (this.$listeners && this.$listeners["map-click-address"]) {
                /// Не делать запрос геокодеру, если нет обработчиков
                this.geoCode(coords);
            }
            if (this.yaMap) {
                this.yaMap.setCenter(coords, this.yaMap.getZoom(), { duration: 300 });
                setTimeout(() => {
                    this.setPlacemark(coords);
                }, 300);
            }
            if (this.promoPolygonObject && this.isPromoPolygonInCurrentRegion) {
                this.isAddressInPromoPolygon = this.promoPolygonObject.geometry.contains(coords);
            }
        },

        /** Установить текущую отметку на карте */
        setPlacemark(coords) {
            if (this.placemarkObject !== null) {
                this.yaMap.geoObjects.remove(this.placemarkObject);
            }
            this.placemarkObject = new ymaps.Placemark(
                coords,
                {},
                {
                    iconLayout: "default#image",
                    iconImageHref: "/docs/5.0/assets/img/evraz/full-pin.svg",
                    iconImageSize: [40, 40],
                    iconimageOffset: [-25, -50],
                }
            );
            this.yaMap.geoObjects.add(this.placemarkObject);
        },

        /** Нужно вызвать после изменения размеров, если карты не видно */
        fitMapToViewport() {
            if (this.yaMap) {
                this.yaMap.container.fitToViewport();
            }
        },

        /**
         * Обновляет полигоны доставки для региона
         */
        changeRegionPolygon(regionId) {
            this.polygonObjectList = [];

            if ((!regionId || !this.$root.JS_DATA.DELIVERY_POLYGONS) && !this.polygons) {
                return false;
            }

            let self = this;
            let isPolygonsVisible = localStorage.getItem("visiblePolygons") == "true";
            let polygons = [];
            let promoPolygon = null;
            if (regionId) {
                // полигоны для калькулятора доставки
                polygons = this.$root.JS_DATA.DELIVERY_POLYGONS.filter(function (polygon) {
                    return polygon.UF_REGION_UID === regionId;
                });
                promoPolygon = this.$root.JS_DATA.PROMO_POLYGONS.filter(function (polygon) {
                    return polygon.UF_REGION_UID === regionId;
                });
                if (promoPolygon.length && promoPolygon[0]["UF_POLYGON_POINTS"]) {
                    this.addPromoPolygon(promoPolygon[0]["UF_POLYGON_POINTS"]);
                } else {
                    this.isPromoPolygonInCurrentRegion = false;
                }
            } else {
                // полигоны для чекаута
                polygons = this.polygons;
            }

            if (Array.isArray(polygons)) {
                polygons.forEach(function (item) {
                    var myPoligon = new ymaps.GeoObject(
                        {
                            geometry: {
                                type: "Polygon",
                                coordinates: [JSON.parse(item.UF_COORDS)],
                                fillRule: "nonZero",
                            },
                            // свойства геообъекта.
                            properties: {
                                uid: item.UF_AREA_UID,
                                regionUid: item.UF_REGION_UID,
                            },
                        },
                        {
                            // опции геообъекта. Оставил для дебага
                            fillColor: "#c50be6",
                            strokeColor: "#1c0021",
                            opacity: isPolygonsVisible ? 0.5 : 0,
                            strokeWidth: isPolygonsVisible ? 3 : 0,
                            strokeStyle: "dashdot",
                            // fill: 0
                        }
                    );
                    self.polygonObjectList.push(myPoligon);
                    myPoligon.events.add("click", (e) => self.onClickMap(e));
                    self.yaMap.geoObjects.add(myPoligon);
                });
            }
        },

        findPolygon(coords, cityXmlCode = undefined) {
            if (!Array.isArray(coords)) {
                return false;
            }
            if (coords.length) {
                coords = [parseFloat(coords[0]), parseFloat(coords[1])];
            }

            var self = this;
            var foundedArea = false;

            if (this.polygonObjectList.length > 0) {
                this.polygonObjectList.forEach(function (item) {
                    if (item.geometry.contains(coords)) {
                        self.selectedZoneUID = item.properties.get("uid");
                        foundedArea = item.properties.get("uid");
                        self.$emit("map-set-polygon", item.properties.get("uid"));
                    }
                });
            }

            if (!foundedArea) {
                self.selectedZoneUID = null;
                self.$emit("map-set-polygon", "");
            }

            return foundedArea;
        },

        findRouteDistance(addressFrom, addressTo) {
            if (!addressFrom || !addressTo) throw new Error("обязательны оба параметра");
            if (this.multiRoute != null) {
                this.multiRoute.destroy();
                this.multiRoute = null;
            }
            this.multiRoute = new ymaps.multiRouter.MultiRoute(
                {
                    referencePoints: [addressFrom, addressTo],
                    params: {
                        // Ограничение на максимальное количество маршрутов, возвращаемое маршрутизатором.
                        results: 1,
                    },
                },
                {
                    // Автоматически устанавливать границы карты так, чтобы маршрут был виден целиком.
                    boundsAutoApply: true,
                }
            );
            return new Promise((resolve, reject) => {
                this.multiRoute.events.once("update", () => {
                    let distance = "";
                    try {
                        const activeRoute = this.multiRoute.getActiveRoute();
                        distance = activeRoute.properties.get("distance").text;
                        resolve(distance);
                    } catch (e) {
                        //console.log('Яндекс не построил маршрут');
                        reject("Яндекс не построил маршрут");
                    }
                });
                setTimeout(() => reject("Яндекс не построил маршрут"), 2000);
            });
        },

        async geoCode1C(coords) {
            var self = this;

            self.$emit("map-block-map", "");

            BX.ajax
                .runComponentAction("evraz.main:delivery.calculator", "getDeliveryCars", {
                    mode: "class",
                    data: {
                        regionUid: self.curentRegionUid,
                        geo_point: self.addressText ? [] : coords,
                        address: self.addressText ? self.addressText : "",
                        type: "geo",
                        basket: self.isCheckout == "Y" ? "Y" : "N",
                    },
                })
                .then(function (resultCarsAction) {
                    if (
                        resultCarsAction.data &&
                        (!resultCarsAction.data.cars || resultCarsAction.data.cars.length <= 0)
                    ) {
                        if (self.isCheckout == "Y") {
                            self.$emit(
                                "map-calculation-error",
                                "Ошибка! После оформления заказа с вами свяжется оператор для уточнения условий доставки"
                            );
                        } else {
                            self.$emit(
                                "map-calculation-error",
                                "Рассчитать доставку по данному адресу не удалось"
                            );
                        }
                    }
                    if (resultCarsAction.data && resultCarsAction.data.address) {
                        let curAddress = resultCarsAction.data.address;
                        if (self.addressText) {
                            curAddress = self.addressText;
                        }
                        let address = {
                            text: curAddress,
                            city: null,
                            coords,
                            cars: resultCarsAction.data.cars,
                            distance: resultCarsAction.data.distance,
                        };
                        self.onMapClick(address);
                    }
                    self.carsLoading = false;
                    self.$emit("map-unblock-map", "");
                })
                .catch(function (e) {
                    self.carsLoading = false;
                    self.$emit("map-unblock-map", "");
                    if (self.isCheckout == "Y") {
                        self.$emit(
                            "map-calculation-error",
                            "Ошибка! После оформления заказа с вами свяжется оператор для уточнения условий доставки"
                        );
                    } else {
                        self.$emit(
                            "map-calculation-error",
                            "При расчёте доставки, произошли технические неполадки"
                        );
                    }
                });
        },

        formatDadataFor1C(suggestion) {
            const data = suggestion.data;
            let resultString = "";

            resultString += data.country ? data.country + ', ' : ',';
            resultString += data.postal_code ? data.postal_code + ', ' : ',';
            resultString += data.region ? data.region + ' ' + data.region_type + ', ' : ',';
            resultString += data.area ? data.area + ' ' + data.area_type + ', ' : ',';
            resultString += data.city ? data.city + ', ' : ',';
            resultString += data.settlement ? data.settlement + ', ' : ',';
            resultString += data.street ? data.street + ', ' : ',';
            resultString += data.house ? data.house + ', ' : ',';
            resultString += ',,';

            return resultString;
        },

        /** https://yandex.ru/dev/maps/jsapi/doc/2.1/ref/reference/geocode.html */
        async geoCode(coords) {
            const [lat, lon] = coords;
            BX.Evraz.getAddressByCoords(
                { lat: lat, lon: lon },
                this,
                callbackSuccess,
                callbackError
            );
            function callbackSuccess(response) {
                const suggestion = response.data.suggestions[0];
                const addressText = suggestion.data.country + ', ' + suggestion.value;
                const city = suggestion.data.city;
                const addressTextFor1C = this.formatDadataFor1C(suggestion);
                let address = { text: addressText, addressTextFor1C: addressTextFor1C, city: city, coords };
                this.onMapClick(address);
            }
            function callbackError(err) {
                console.log(err);
                return false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
div {
    width: 100%;
    height: 100%;
}

/* Скрыть копирайты yandex maps */

::v-deep ymaps[class$="-copyrights-pane"] {
    display: none;
}
</style>
